import {FC, useMemo} from 'react';
import {useRecoilValue} from 'recoil';

import NavCards from '../../ui/nav-cards/NavCards';

import {authState} from '../../store/auth/atoms';

import styles from './Settings.module.scss';
import {TypeAccountRoles} from '../../shared/types/user-account.types';

const SettingsPage: FC = () => {
  const {user} = useRecoilValue(authState);
  const isManager = useMemo(() => user?.roles?.filter((i) => i === TypeAccountRoles.MANAGER).length === 1, [user]);

  return (
    <div className={styles.settings}>
      <div className={styles.navCards}>
        <NavCards
          variant="grid"
          menu={[...(isManager ? [{link: `/settings/importDevices`, title: 'Импорт справочника устройств'}] : [])]}
          sxTitle={{fontSize: '13px'}}
        />
      </div>
    </div>
  );
};

export default SettingsPage;
